import * as React from "react";
import Svg, { Path, Rect, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});
cssInterop(Rect, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { 
      fill: true,
      stroke: true,
    },
  },
});

type CheckedIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
  rectFillClassName?: string;
  rectStrokeClassName?: string;
};

function CheckedIcon({
  className,
  pathClassName = "stroke-white",
  rectFillClassName = "fill-white",
  rectStrokeClassName = "stroke-gray-200",
  ...props
}: CheckedIconProps) {
  return (
    <Svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      {...props}
    >
      <Rect x={0.5} y={0.5} width={19} height={19} rx={1.5} fill="#319795" className={rectFillClassName} />
      <Rect x={0.5} y={0.5} width={19} height={19} rx={1.5} stroke="#319795" className={rectStrokeClassName} />
      <Path
        d="M4.952 10.854l3.333 3.125 6.666-8.333"
        stroke="#fff"
        strokeWidth={2}
        strokeLinejoin="round"
        className={pathClassName}
      />
    </Svg>
  );
}

export default CheckedIcon;
